<template>
  <div>
    <div v-if="isWorking" class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-4x"/>
    </div>
    <b-card no-body v-else>
      <b-tabs content-class="my-0 mx-0 pb-0 no-border" v-model="tab" justified card>
        <b-tab title="Upload from Computer" no-body>
          <b-card class="mb-0">
            <upload-with-drag-and-drop
              :file-type="fileType"
              :project="project"
              @fail="fileUploadFail"
              @success="handleFilePick"/>
          </b-card>
        </b-tab>
        <!-- <b-tab title="Pick from Library" lazy no-body :disabled="!hasFiles">
          <b-card class="mb-0">
            <file-picker
              :type="fileType"
              :project="project"
              @pick="handleFilePick"/>
          </b-card>
        </b-tab> -->
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
  import UploadWithDragAndDrop from './UploadWithDragAndDrop';
  import FilePicker from './FilePicker';
  import {saveActiveFilesChanges} from '../../store/files';

  export default {
    name: 'UploadOrLibrary',
    components: {UploadWithDragAndDrop, FilePicker},
    props: {
      fileType: String,
      project: Object
    },
    data() {
      // const hasFiles = this.$store.state.files.fileList.some(file => file.type === this.fileType);
      const hasFiles = Object.keys(this.project.files).indexOf(this.fileType) > -1;

      return {
        hasFiles,
        tab: hasFiles ? 1 : 0,
        isWorking: false
      };
    },

    methods: {
      handleFilePick(fileID) {
        const mapping = {[this.fileType]: fileID};
        this.isWorking = true;
        this.$store.dispatch(saveActiveFilesChanges(mapping))
          .then(() => {
            this.$emit('success', {'fileID': fileID, 'projectID': this.project['id']});
          })
          .catch(console.log)
          .finally(() => {
            this.isWorking = false;
          });
      },

      fileUploadFail(data) {
        this.isWorking = false;
        this.$emit('fail', {'fileID': data.fileID, 'recordsLeft': data.recordsLeft, 'rowCount': data.rowCount, 'projectID': this.project['id']});
      }
    }
  };
</script>

<style>
  .no-border {
    border: none !important;
  }
</style>
